// extracted by mini-css-extract-plugin
export default {"card":"BCCNel9zsBKj5yAIXkOe","appear":"Ddw4EVi5PoG77HtgrkYN","slide":"xWpb7shK1e9i844oNVK1"};